import styled from 'styled-components'

export const PaddingView = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
`

export const SidePaddingView = styled.div`
  padding-left: ${(props) => props.value || '16px'};
  padding-right: ${(props) => props.value || '16px'};
`

export const TopBottomPaddingView = styled.div`
  width: 100%;
  padding-top: ${(props) => props.value || '8px'};
  padding-bottom: ${(props) => props.value || '8px'};
`

export const BlankPaddingView = styled.div`
  width: 100%;
  height: ${(props) => props.value};
`
